import { CircleChevronRight } from "lucide-react";
import React from "react";
import { about_img } from "../assets";
import { Link } from "react-router-dom";

const AboutUs = () => {
  const about_points = [
    "Hands-on workshops with leading dental experts",
    "Expert-led sessions on clinical excellence and innovation",
    "Latest advancements in dental technology showcased",
    // "Opportunities to expand knowledge and transform practice"
  ];

  return (
    <div className="flex flex-col md:flex-row gap-2 md:h-[90vh] bg-pimary items-center justify-center p-4 md:px-12 md:py-4">
      {/* Image Section */}
      <div className="flex justify-center">
        <img
          src='https://img.freepik.com/free-photo/dentist-doing-check-up-patient_23-2149206225.jpg?uid=R75564813&ga=GA1.1.1422450455.1747647704&semt=ais_hybrid&w=740'
          alt="Dental Conference 2025"
          loading="lazy"
          className="h-[40vh] md:h-[70vh] w-auto md:w-[80vh] mx-auto md:mx-16 rounded-xl object-cover"
        />
      </div>

      {/* Text Content */}
      <div className="flex flex-col w-full md:w-2/3">
        <h1 className="text-xl md:text-3xl font-bold my-2">
          <span className="text-one">Advancing Dentistry</span> Through Innovation and Insight
        </h1>
        <p className="text-base my-2">
          Join leading professionals at the Dental Conference 2025, where innovation meets clinical excellence. Experience hands-on workshops, expert-led sessions, and the latest advancements in dental technology. This global event is your gateway to transforming practice, expanding knowledge, and shaping the future of dentistry.
        </p>
        <blockquote className="italic text-one my-2 border-l-4 border-one pl-4">
          “Our dental conference is designed to inspire and empower professionals”
        </blockquote>
        <div className="flex flex-col gap-3 mt-4">
          {about_points.map((item, idx) => (
            <div key={idx} className="flex flex-row gap-2 items-start">
              <CircleChevronRight
                size={24}
                className="text-one flex-shrink-0 mt-1"
              />
              <p className="text-sm md:text-base">{item}</p>
            </div>
          ))}
        </div>
        <Link to="/about">
          <button className="flex bg-black text-one px-6 md:px-8 py-2 my-4 rounded-full text-sm md:text-base">
            Know More
          </button>
        </Link>
      </div>
    </div>
  );
};

export default AboutUs;
